"use strict";
exports.__esModule = true;
exports.capitalizeFirstLetter = void 0;
function capitalizeFirstLetter(s) {
    if (!s)
        return '';
    return s[0].toUpperCase() + s.slice(1);
}
exports.capitalizeFirstLetter = capitalizeFirstLetter;
